import { render, staticRenderFns } from "./ScoringSettings.vue?vue&type=template&id=3aae0c36&"
import script from "./ScoringSettings.vue?vue&type=script&lang=js&"
export * from "./ScoringSettings.vue?vue&type=script&lang=js&"
import style0 from "./ScoringSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports